import {
  SUCCESS_FLASH_MESSAGE,
  ERROR_FLASH_MESSAGE,
  HIDE_FLASH_MESSAGE,
} from '../types/FlashTypes';

export const setSuccessMessage = (message) => {
  return { type: SUCCESS_FLASH_MESSAGE, message };
};

export const setErrorMessage = (message) => {
  return { type: ERROR_FLASH_MESSAGE, message };
};

export const hideMessage = () => {
  return { type: HIDE_FLASH_MESSAGE };
};

export const successMessage = (message) => {
  return (dispatch) => {
    dispatch(setSuccessMessage(message));
  };
};
export const errorMessage = (message) => {
  return (dispatch) => {
    dispatch(setErrorMessage(message));
  };
};
